import { useEffect, useState } from 'react'

import { queryMicPermission } from '../lib/micPermission'

/**
 * The browser's microphone permission, kept current (`PermissionStatus.onchange`):
 * a site blocked in the browser shows as such before any tap, and unblocking
 * it brings the button back without a reload.
 */
export function useMicPermission() {
  const [permission, setPermission] = useState('unknown')

  useEffect(() => {
    let live = true
    let status = null
    void queryMicPermission().then((answer) => {
      if (!live || !answer) return
      status = answer
      setPermission(answer.state)
      answer.onchange = () => setPermission(answer.state)
    })
    return () => {
      live = false
      if (status) status.onchange = null
    }
  }, [])

  return { permission }
}
